var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "senWord-detail" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "senWord-dialog",
          staticStyle: { "margin-top": "5vh" },
          attrs: {
            visible: _vm.dialogShow,
            "modal-append-to-body": false,
            width: "704px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
            [_vm._v(_vm._s(_vm.wordName))]
          ),
          _c("div", { staticClass: "wrap" }, [
            _c("div", { staticClass: "wrap-top" }, [
              _c("div", { staticClass: "classification" }, [
                _c("span", [
                  _vm._v(
                    "归属：" +
                      _vm._s(
                        _vm.classifiName && _vm.classifiName != null
                          ? _vm.classifiName
                          : "-"
                      )
                  )
                ])
              ]),
              _c(
                "div",
                { staticClass: "btn-wrap" },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "240px", "margin-right": "10px" },
                    attrs: {
                      size: "mini",
                      type: "daterange",
                      editable: false,
                      "value-format": "yyyy-MM-dd",
                      "range-separator": "~",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "picker-options": _vm.pickerOptions,
                      clearable: false
                    },
                    on: { change: _vm.selectTime },
                    model: {
                      value: _vm.searchSelectTime,
                      callback: function($$v) {
                        _vm.searchSelectTime = $$v
                      },
                      expression: "searchSelectTime"
                    }
                  }),
                  _vm.mgctjdcygmx
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.handleExport }
                        },
                        [_vm._v("导出")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "wrap-body" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.flag,
                        expression: "flag"
                      }
                    ],
                    ref: "cusChatTable",
                    staticStyle: { "font-size": "13px" },
                    attrs: {
                      size: "small",
                      data: _vm.tableData,
                      fit: "",
                      "highlight-current-row": "",
                      "header-cell-style": { background: "#F9F9F9" },
                      height: "400",
                      "empty-text": "暂无敏感词的违规情况"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "users",
                        label: "员工",
                        "min-width": "150"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "department",
                        label: "所属部门",
                        "min-width": "150"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "hitCount",
                        label: "出现次数",
                        "min-width": "150"
                      }
                    })
                  ],
                  1
                ),
                _c("Pagination", {
                  attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
                  on: { callBack: _vm.callBack }
                })
              ],
              1
            )
          ]),
          _c("div", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }